module.exports = __webpack_public_path__ + "static/img/品牌数据引擎.23287b27.png";